import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MomentModule } from 'angular2-moment';

import { PaymentTransactionsRoutingModule } from './paymentTransactions-routing.module';
import { PaymentTransactionsFilterComponent } from './components/scripts/paymentTransactionsFilter.component';
import { PaymentTransactionsService } from './services/paymentTransactions.service';
import { ProductTypesService } from './services/productTypes.service';
import { TransactionModalComponent } from './components/scripts/transactionModal.component';
import { ProductStatsModalComponent } from './components/scripts/productStatsModal.component';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { ProductStatsService } from './services/productStats.service';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { UsersSiteService } from '../shared/services/usersSite.service';

export const MY_MOMENT_FORMATS = {
  parseInput: 'l LT',
  fullPickerInput: 'l LT',
  datePickerInput: 'LL',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PaymentTransactionsRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    MomentModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule
  ],
  declarations: [
    PaymentTransactionsFilterComponent,
    TransactionModalComponent,
    ProductStatsModalComponent
  ],
  providers: [
    UsersSiteService,
    PaymentTransactionsService,
    ProductTypesService,
    ProductStatsService,
    {provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS}
  ],
  entryComponents: [TransactionModalComponent, ProductStatsModalComponent]
})

export class PaymentTransactionsModule { }



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/paymentTransactions.module.ts